export default "__VITE_ASSET__Bcxyf_Ll__"